// Importing module
var SHA256 = require("crypto-js/sha256");

const Hash = (plainText) => {
    return SHA256(plainText)+"";
};
export default Hash;